export { default as HomeIcon } from './HomeIcon';
